import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import locationPng from "../../assets/location.png";
import bedPng from "../../assets/bed.png";
import scalePng from "../../assets/scale.png";
import bathtubPng from "../../assets/bathtub.png";
import { slugify } from '../../utils/slugify';

const Content = ({ data }) => {
  const [index, setIndex] = useState(0);
  const [holidayRealEstate, setHolidayRealEstate] = useState([]);
  const [sortOrder, setSortOrder] = useState("latest");
  const propertiesPerPage = 9;
  const navigate = useNavigate();

  useEffect(() => {
    setHolidayRealEstate(data.filter((property) => property.status === "approved"));
  }, [data]);

  const totalPages = Math.ceil(holidayRealEstate.length / propertiesPerPage);

  const handleClick = (property) => {
    navigate(`/property/${slugify(property.name)}`);
  };

  const handleSort = (order) => {
    const sorted = [...holidayRealEstate];
    switch (order) {
      case "latest":
        sorted.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case "max-price":
        sorted.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
        break;
      case "min-price":
        sorted.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
        break;
      default:
        break;
    }
    setHolidayRealEstate(sorted);
    setSortOrder(order);
  };

  const renderProperties = (start) =>
    holidayRealEstate
      .slice(start, start + propertiesPerPage)
      .map((property, key) => (
        <div
          key={key}
          className="px-2 pb-2 md:px-8 md:pb-8 w-[90vw] md:w-[45vw] lg:w-[30vw]"
          onClick={() => handleClick(property)}
        >
          <div className="border rounded shadow-md p-1 border-[#E9E9E9]">
            <div className="relative overflow-hidden">
              <img
                src={property.images[0]}
                alt={property.name}
                className="h-[40vh] w-full object-cover rounded-sm duration-300 hover:scale-110"
              />
            </div>
            <div className="flex flex-col px-[3%]">
              <div className="flex justify-between items-center pt-4">
                <div className="text-left text-lg font-semibold text-black">
                  {property.name?.replace(/[-\d]/g, " ") || ""}
                </div>
                <div className="text-md font-semibold text-black">
                  {property.price > 0 ? `${property.price} AED` : "Contact Us"}
                </div>
              </div>
              <div className="flex py-2">
                <div className="flex flex-col">
                  <div className="flex items-center text-base md:text-lg font-semibold">
                    {property.bedrooms}
                    <img src={bedPng} alt="bed" className="w-4 h-4 md:w-8 md:h-8 mx-2" />
                  </div>
                </div>
                <div className="flex flex-col mx-4">
                  <div className="flex items-center text-base md:text-lg font-semibold">
                    {property.bathrooms}
                    <img src={bathtubPng} alt="bath" className="w-4 h-4 md:w-8 md:h-8 mx-2" />
                  </div>
                </div>
                <div className="flex flex-col">
                  <div className="flex items-center text-base md:text-lg font-semibold">
                    {property.square}
                    <img src={scalePng} alt="area" className="w-4 h-4 md:w-8 md:h-8 mx-2" />
                  </div>
                </div>
              </div>
              <div className="flex items-center text-sm text-gray-400 py-1">
                <img src={locationPng} alt="location" className="w-4 m-1" />
                <div>{property.location}</div>
              </div>
            </div>
          </div>
        </div>
      ));

  return (
    <div className="relative *:font-sans">
      <div className="my-5 ml-[7%] text-3xl font-semibold text-left">
        Holiday Homes
      </div>
      {holidayRealEstate.length === 0 ? (
        <div className="py-20 text-xl text-center text-gray-600">
          No properties found.
        </div>
      ) : (
        <>
          <div className="my-5 ml-[7%] flex items-center">
            <select
              value={sortOrder}
              onChange={(e) => handleSort(e.target.value)}
              className="px-4 py-2 bg-white border rounded"
            >
              <option value="latest">Latest</option>
              <option value="max-price">By Maximum Price</option>
              <option value="min-price">By Minimum Price</option>
            </select>
          </div>
          <div className="flex flex-col md:flex-row flex-wrap justify-center items-center">
            {renderProperties(index * propertiesPerPage)}
          </div>
          <div className="relative mb-12 mx-auto flex justify-center sm:my-[2%]">
            {Array.from({ length: totalPages }, (_, i) => (
              <div
                key={i}
                onClick={() => setIndex(i)}
                className={`mx-2 px-6 py-5 border border-black duration-300 cursor-pointer ${
                  index === i
                    ? "bg-black text-white"
                    : "hover:bg-black hover:text-white"
                }`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Content;
